import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TEASER_BIG_VIDEO_CONVERTER_TOKEN, TeaserBigVideoConverter } from './teaser-big-video.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        teaserBigVideoFeature: {
          module: () => import('./teaser-big-video.module').then((m) => m.TeaserBigVideoModule),
          cmsComponents: ['teaser_big_video'],
        },
      }
    }),
    {
      provide: TEASER_BIG_VIDEO_CONVERTER_TOKEN,
      useClass: TeaserBigVideoConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        teaser_big_video: TEASER_BIG_VIDEO_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class TeaserBigVideoFeatureModule {}
